import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const FinalCTASection = memo(function FinalCTASection() {
  const CHECKOUT_URL = '#compra';
  return;
});